export var URL_TYPES;
(function (URL_TYPES) {
    URL_TYPES["VIDEO"] = "video";
    URL_TYPES["CHANNEL"] = "channel";
    URL_TYPES["USER_NAME"] = "username";
    URL_TYPES["PLAYLIST"] = "playlist";
})(URL_TYPES || (URL_TYPES = {}));
//# sourceMappingURL=url-types.js.map